import Vue from 'vue'

const MAX_CART_ITEMS = 20
const store = localStorage
const service = new Vue()

const getOrder = () => {
  let order
  try {
    let data = store.getItem('order')
    order = JSON.parse(data)
    // console.log('Order', data)
    // if (!data || data !== 'undefined') {
    //   order = JSON.parse(data)
    //   localStorage.removeItem('order')
    // }
  } catch (e) {
    console.error(e)
  }
  return order
}

const getItems = () => {
  let items = []
  try {
    let _record = getOrder() // store.getItem('order')
    if (!_record) return {items, length: items.length}
    let order = _record
    if (!order.products) return
    order.products.map((item) => {
      if (item.image_url.split(':').length < 2) {
        item.image_url = `http://${item.image_url}`
      }
      items.push(item)
    })
  } catch (e) {
    console.error(e)
  }
  return {items, length: items.length}
}

const getShipping = () => {
  let shipping = {}
  try {
    let _record = getOrder() // store.getItem('order')
    if (!_record) return {}
    let order = _record
    shipping = order.shipping
  } catch (e) {
    console.error(e)
  }
  return shipping
}

const count = () => getItems().length

const totalAmount = () => {
  let total = 0
  let items = getItems().items
  let shipping = getShipping()
  items.forEach((item) => {
    if (isNaN(item.price)) return
    total = total + parseInt(item.price)
  })
  if (shipping.shipping_total) {
    total = total + shipping.shipping_total
  }
  return total
}

export {
  count,
  service,
  getItems,
  getShipping,
  totalAmount,
  getOrder,
  MAX_CART_ITEMS
}



// WEBPACK FOOTER //
// ./src/services/shopping-cart.js